module.exports = __webpack_public_path__ + "img/ico044.80ef7778.svg";